var _path, _path2, _path3, _path4, _circle;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcColoredPhoneCall(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 38,
    height: 38,
    viewBox: "0 0 38 38",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.38375 5.45975C4.65379 6.22813 4.25 7.26243 4.25 8.33333V31.6667C4.25 32.7376 4.65379 33.7719 5.38375 34.5402C6.11495 35.3099 7.11513 35.75 8.16667 35.75H20.8333C21.8849 35.75 22.8851 35.3099 23.6163 34.5403C24.3462 33.7719 24.75 32.7376 24.75 31.6667V8.33333C24.75 7.26243 24.3462 6.22813 23.6163 5.45975C22.8851 4.69006 21.8849 4.25 20.8333 4.25H8.16667C7.11513 4.25 6.11495 4.69006 5.38375 5.45975Z",
    stroke: "#20242E",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16 4.25H13V5V5.75H16V5V4.25Z",
    stroke: "#20242E",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M28.7598 18.7571C29.4655 19.3607 29.8516 20.1957 29.8331 21.0784C29.8146 21.9611 29.393 22.8191 28.661 23.4637",
    stroke: "#0E5CF4",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M31.3389 14C33.4713 15.8239 34.6379 18.3469 34.5819 21.0138C34.5259 23.6807 33.2521 26.2732 31.0405 28.2209",
    stroke: "#0E5CF4",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 15,
    cy: 31,
    r: 2,
    fill: "#0E5CF4"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcColoredPhoneCall);
export default __webpack_public_path__ + "static/media/ic-colored-phone-call.94eb598432914e15439cfec164dd73c5.svg";
export { ForwardRef as ReactComponent };